import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faOpenLink from '@fortawesome/fontawesome-free-solid/faWindowRestore';
import marked from 'marked';
// import NumberFormat from 'react-number-format';

class ProductInfo extends Component{

  render(){
    const { product } = this.props;
    let field1;
    let field2;
    let field3;    
    if(product.field1){
      field1 = <div className="sub-info-field" >
        {product.field1_link ? <a href={product.field1_link} target="_blank" rel="noopener noreferrer">{product.field1}</a> : product.field1}
      </div>;
    }
    if(product.field2){
      field2 = <div className="sub-info-field" >
        {product.field2_link ? <a href={product.field2_link} target="_blank" rel="noopener noreferrer">{product.field2}</a> : product.field2}
      </div>;
    }
    if(product.field3){
      field3 = <div className="sub-info-field" >
        {product.field3_link ? <a href={product.field3_link} target="_blank" rel="noopener noreferrer">{product.field3}</a> : product.field3}
      </div>;
    }
    
    return (
      <div className="content product-content">
        <p className="description" dangerouslySetInnerHTML={{ __html: marked(product.description || "") }} />
        <div className="sub-info">
          {product.price && 
            <div className="sub-info-price" >
              <span>建議售價</span>
              <span>{product.price}</span>
            </div>
          }
          {field1}
          {field2}
          {field3}
          {product.link && 
            <div className="sub-info-original-link" >
              <a href={product.link} target="_blank" rel="noopener noreferrer">
                <span>原廠連結</span>
                <FontAwesomeIcon icon={faOpenLink}/>
              </a>
            </div>
          }
        </div>        
      </div>
    );
  }
}

ProductInfo.propTypes = {
  product: PropTypes.shape({
  }),
};

export default ProductInfo;


// WEBPACK FOOTER //
// ./src/components/ProductInfo.js